import { useState, FC } from "react";
import { Button, Checkbox, Col, Form, Modal, Row, TimePicker } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import AddBreakForm from "./AddBreakForm";
import { editSVG } from "../../../../assets/SVGs/SVGs";
import AddTime from "./AddTime";
import { formateTimeToAMPM, getWeekDays } from "../../../../utils/DateUtils";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import arLocale from "antd/es/date-picker/locale/ar_EG";
import enLocale from "antd/es/date-picker/locale/en_US";
import { location } from "../../../../types/calendar";
import {
  breaks,
  workingHoursAndShiftResponse,
} from "../../../../types/teamMember";
import DeleteModal from "../../../common/DeleteModal";
import { MdOutlineDeleteForever } from "react-icons/md";
import { adminDeleteWorkingHours } from "../../../../network/admin";

const staticWeekDays: shiftDay[] = [
  {
    day_string: "saturday",
    breaks: [],
    from: "09:00",
    off: true,
    to: "18:00",
    salonOff: true,
  },
  {
    day_string: "sunday",
    breaks: [],
    from: "09:00",
    off: true,
    to: "18:00",
    salonOff: true,
  },
  {
    day_string: "monday",
    breaks: [],
    from: "09:00",
    off: true,
    to: "18:00",
    salonOff: true,
  },
  {
    day_string: "tuesday",
    breaks: [],
    from: "09:00",
    off: true,
    to: "18:00",
    salonOff: true,
  },
  {
    day_string: "wednesday",
    breaks: [],
    from: "09:00",
    off: true,
    to: "18:00",
    salonOff: true,
  },
  {
    day_string: "thursday",
    breaks: [],
    from: "09:00",
    off: true,
    to: "18:00",
    salonOff: true,
  },
  {
    day_string: "friday",
    breaks: [],
    from: "09:00",
    off: true,
    to: "18:00",
    salonOff: true,
  },
];

type shiftDay = {
  day_string: string;
  from: string;
  to: string;
  off: boolean;
  breaks: {
    from: string;
    to: string;
    typeId: number;
    approved: boolean;
  }[];
  salonOff?: boolean;
};
interface AddScheduleProps {
  onClose: () => void;
  team_member_id: number;
  location_id: number;
  selectedDate: string;
  config?: {
    isAdmin?: boolean;
    isEdit?: boolean;
    workingHourId?: number;
    workingHoursWithShifts?: workingHoursAndShiftResponse;
  };
  locationDetails?: location;
}

const AddSchedule: FC<AddScheduleProps> = ({
  team_member_id,
  location_id,
  selectedDate,
  onClose,
  config,
  locationDetails,
}) => {
  const intl = useIntl();
  const { currentLang } = useSelector(
    (state: {
      user: { currentLang: "en" | "ar" };
      calendar: { activeLocation: location | null };
    }) => {
      return {
        currentLang: state?.user?.currentLang,
        activeLocation: state.calendar.activeLocation,
      };
    }
  );
  const [form] = Form.useForm();
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [shiftBreakIndex, setShiftBreakIndex] = useState<number | null>(null);
  const [dayBreakIndex, setDayBreakIndex] = useState<number>(0);
  const [step, setStep] = useState(1);

  const [shiftDays, setShiftDays] = useState<shiftDay[]>(() => {
    const days = staticWeekDays.map((day) => {
      const existedDay = locationDetails?.opening_hours?.find(
        (d) => d?.day?.toLocaleLowerCase() === day?.day_string
      );

      if (existedDay !== undefined) {
        let from: string[] = [];
        let to: string[] = [];
        let breaks: breaks[] = [];
        let id: number = -1;
        let off: boolean = false;
        if (config?.isEdit && config?.workingHoursWithShifts?.working_shifts) {
          let memberDay = config?.workingHoursWithShifts?.working_shifts?.find(
            (d) =>
              d.day?.toLocaleLowerCase() === day.day_string?.toLocaleLowerCase()
          );
          if (memberDay) {
            from = memberDay?.start_time?.split(":");
            to = memberDay?.end_time?.split(":");
            breaks = memberDay?.breaks;
            id = memberDay?.id;
            if (memberDay?.off === 1) {
              off = true;
              from = "09:00".split(":");
              to = "18:00".split(":");
            }
          }
        } else {
          from = existedDay?.opening_time?.split(":");
          to = existedDay?.closing_time?.split(":");
        }
        if (!from?.length || !to?.length) {
          from = existedDay?.opening_time?.split(":");
          to = existedDay?.closing_time?.split(":");
        }
        const existWorkingDay: any = {
          // ...existedDay,
          day_string: existedDay?.day?.toLocaleLowerCase(),
          from: [from[0], from[1]].join(":") || "09:00",
          to: [to[0], to[1]].join(":") || "18:00",
          off: off,
          breaks: breaks?.map((breakItem: any) => {
            return {
              ...breaks,
              from: [
                breakItem?.from?.split(":")[0],
                breakItem?.from?.split(":")[1],
              ].join(":"),
              to: [
                breakItem?.to?.split(":")[0],
                breakItem?.to?.split(":")[1],
              ].join(":"),
              typeId: breakItem?.typeId,
              approved: breakItem?.approved || false,
            };
          }),
          salonOff: false,
        };

        if (id !== -1) {
          existWorkingDay.id = id;
        }

        return existWorkingDay;
      } else {
        return day;
      }
    });
    return days;
  });
  console.log(shiftDays);

  const workingDays: { dayString: string; open: string; close: string }[] =
    locationDetails
      ? locationDetails?.opening_hours?.map((day) => ({
          close: day?.closing_time,
          open: day?.opening_time,
          dayString: day?.day,
        }))
      : [];
  dayjs.extend(isBetween);

  const closeBreakModal = () => {
    setShiftBreakIndex(null);
  };
  const handleAddBreak = (
    index: number,
    breakIndex: number,
    shiftBreak: {
      from: string;
      to: string;
      description?: string;
      typeId: number;
      approved: boolean;
    }
  ) => {
    const newShifts = [...shiftDays];
    newShifts[index].breaks[breakIndex] = shiftBreak;

    setShiftDays(newShifts);
    closeBreakModal();
  };
  const handleDeleteBreak = (index: number, breakIndex: number) => {
    const newShifts = [...shiftDays];
    newShifts[index].breaks.splice(breakIndex, 1);
    setShiftDays(newShifts);
    closeBreakModal();
  };
  const daysOfWeek =
    currentLang === "ar"
      ? {
          saturday: "السبت",
          sunday: "الاحد",
          monday: "الاثنين",
          tuesday: "الثلاثاء",
          wednesday: "الاربعاء",
          thursday: "الخميس",
          friday: "الجمعة",
        }
      : {
          saturday: "Saturday",
          sunday: "Sunday",
          monday: "Monday",
          tuesday: "Tuesday",
          wednesday: "Wednesday",
          thursday: "Thursday",
          friday: "Friday",
        };
  const formatTime = "h:mm";

  return (
    <>
      {step === 1 ? (
        <div className="w-full flex justify-center">
          <Form
            name="complex-form"
            // onFinish={onFinish}
            layout="vertical"
            className="form-style"
            form={form}
          >
            {shiftDays.map((day, index) => (
              <div key={index} className="mb-4">
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 12 }}>
                  <Col
                    className="gutter-row"
                    xl={24}
                    lg={12}
                    xs={24}
                    sm={24}
                    span={11}
                  >
                    <Form.Item
                      name={["regular_shifts", "day"]}
                      className="w-full !my-0"
                      required={false}
                      initialValue={!day?.off} // Set initial value based on checkedDays
                    >
                      <Checkbox
                        className="text-color-primary"
                        onChange={(e) => {
                          console.log("Checkbox changed:", e);
                          const newShiftDays = [...shiftDays];
                          newShiftDays[index].off = !e.target.checked;

                          setShiftDays(newShiftDays);
                        }}
                        checked={!day?.off}
                        disabled={day?.salonOff}
                      >
                        {
                          daysOfWeek[
                            day?.day_string?.toLocaleLowerCase() as keyof typeof daysOfWeek
                          ]
                        }
                      </Checkbox>
                    </Form.Item>
                  </Col>
                </Row>
                {!day.off ? (
                  <Row key={index} gutter={{ xs: 8, sm: 16, md: 24, lg: 12 }}>
                    <Col xl={10} lg={8} xs={24} sm={24}>
                      <Form.Item
                        label={
                          <span className="capitalize">
                            {intl.formatMessage({
                              id: "shiftStart",
                              defaultMessage: "بداية الدوام",
                            })}
                          </span>
                        }
                        className="w-full"
                        required={false}
                        name={`start_time_${day.day_string}`}
                      >
                        <TimePicker
                          format={"hh:mm A"}
                          locale={currentLang === "ar" ? arLocale : enLocale}
                          placeholder={intl.formatMessage({
                            id: "shiftStart",
                            defaultMessage: "بداية الدوام",
                          })}
                          id="input-with-icon-adornment"
                          defaultValue={dayjs(day.from, "HH:mm")}
                          onChange={(val) => {
                            if (!val) return;
                            const newShiftDays = [...shiftDays];
                            newShiftDays[index].from = val.format("HH:mm");

                            setShiftDays(newShiftDays);
                          }}
                          minuteStep={5}
                          disabledTime={(time) => {
                            const selectedStartTime = day.from;
                            if (selectedStartTime) {
                              const disabledHours = Array.from(
                                { length: 24 },
                                (_, hour) => hour
                              );
                              const workingDay = workingDays?.find(
                                (d) =>
                                  d?.dayString?.toLocaleLowerCase() ===
                                  day?.day_string?.toLocaleLowerCase()
                              );
                              if (!workingDay) return {};
                              const startHour =
                                +workingDay?.open?.split(":")[0];
                              const endHour = +workingDay?.close?.split(":")[0];
                              const newDisabled = disabledHours?.filter(
                                (hour) => hour < +startHour || hour > +endHour
                              );
                              const disabledMinutes = Array.from(
                                { length: 60 },
                                (_, minute) => minute
                              );
                              const startMinute =
                                +selectedStartTime.split(":")[1];
                              disabledMinutes.splice(startMinute, 60);
                              const disabled = {
                                disabledHours: () => newDisabled,
                                // disabledMinutes: () => disabledMinutes,
                              };

                              return disabled;
                            }
                            return {};
                          }}
                          needConfirm={false}
                        />
                      </Form.Item>
                    </Col>
                    <Col xl={10} lg={8} xs={24} sm={24}>
                      <Form.Item
                        label={
                          <span className="capitalize">
                            {intl.formatMessage({
                              id: "shiftEnd",
                              defaultMessage: "نهاية الدوام",
                            })}
                          </span>
                        }
                        className="w-full"
                        required={false}
                        name={`end_time_${day.day_string}`}
                      >
                        <TimePicker
                          format={"hh:mm A"}
                          locale={currentLang === "ar" ? arLocale : enLocale}
                          placeholder={intl.formatMessage({
                            id: "shiftEnd",
                            defaultMessage: "نهاية الدوام",
                          })}
                          id="input-with-icon-adornment"
                          defaultValue={dayjs(day.to, "HH:mm")}
                          minuteStep={5}
                          onChange={(val) => {
                            if (!val) return;

                            const newShiftDays = [...shiftDays];
                            newShiftDays[index].to = val.format("HH:mm");

                            setShiftDays(newShiftDays);
                          }}
                          disabledTime={() => {
                            const selectedStartTime = day.from;
                            if (selectedStartTime) {
                              const disabledHours = Array.from(
                                { length: 24 },
                                (_, hour) => hour
                              );
                              const startHour =
                                +selectedStartTime.split(":")[0];
                              const workingDay = workingDays?.find(
                                (d) =>
                                  d?.dayString?.toLocaleLowerCase() ===
                                  day?.day_string?.toLocaleLowerCase()
                              );
                              if (!workingDay) return {};
                              const dayEndHour =
                                +workingDay?.close?.split(":")[0];
                              const newDisabledHours = disabledHours?.filter(
                                (hour) => hour < startHour || hour > dayEndHour
                              );
                              const disabledMinutes = Array.from(
                                { length: 60 },
                                (_, minute) => minute
                              );
                              const startMinute =
                                +selectedStartTime.split(":")[1];
                              disabledMinutes.splice(startMinute, 60);
                              return {
                                disabledHours: () => newDisabledHours,
                                disabledMinutes: () => disabledMinutes,
                              };
                            }
                            return {};
                          }}
                          needConfirm={false}
                        />
                      </Form.Item>
                    </Col>
                    {day.breaks.length > 0
                      ? day.breaks.map((dayBreak, i) => (
                          <div className="flex gap-2 items-center justify-center my-2  w-full  -mt-4 ms-0 md:-ms-20">
                            <Button
                              onClick={() => {
                                setShiftBreakIndex(index);
                                setDayBreakIndex(i);
                              }}
                              type="text"
                              icon={editSVG}
                            >
                              {formateTimeToAMPM(dayBreak.from)} {" - "}
                              {formateTimeToAMPM(dayBreak.to)}
                            </Button>
                          </div>
                        ))
                      : null}
                    {day.breaks.length < 3 ? (
                      <div className="flex justify-center  w-full  -mt-4 ms-0 md:-ms-20">
                        <Button
                          onClick={() => {
                            setShiftBreakIndex(index);
                            setDayBreakIndex(day.breaks.length);
                          }}
                          type="text"
                          icon={
                            <PlusOutlined className="bg-[#00086D]  text-white text-sm  rounded-md p-1 " />
                          }
                        >
                          {intl.formatMessage({
                            id: "addBreak",
                            defaultMessage: "أضف إستراحة",
                          })}
                        </Button>
                      </div>
                    ) : null}
                  </Row>
                ) : (
                  <div>
                    <p>
                      {intl.formatMessage({
                        id: "vacation",
                        defaultMessage: "إجازة",
                      })}{" "}
                      {day?.salonOff ? (
                        <span className="text-[#75757E] mx-2 text-sm">
                          {" ( "}
                          {intl.formatMessage({
                            id: "salonIsClosed",
                          })}{" "}
                          {" )"}
                        </span>
                      ) : null}
                    </p>
                  </div>
                )}
              </div>
            ))}
            <Modal
              width={700}
              open={shiftBreakIndex === null ? false : true}
              onCancel={() => setShiftBreakIndex(null)}
              footer={null}
              destroyOnClose
              maskClosable={false}
            >
              {shiftBreakIndex !== null ? (
                <AddBreakForm
                  shiftBreak={shiftDays[shiftBreakIndex]?.breaks[dayBreakIndex]}
                  index={shiftBreakIndex}
                  breakIndex={dayBreakIndex}
                  handleAddBreak={handleAddBreak}
                  handleDeleteBreak={handleDeleteBreak}
                  handleClose={closeBreakModal}
                  selectedDate={
                    getWeekDays(new Date(selectedDate))[shiftBreakIndex]
                      ?.dayDate
                  }
                />
              ) : null}
            </Modal>
            <div className="flex flex-col md:flex-row gap-2">
              <Col xl={12} lg={12} xs={24} sm={24}>
                <Button
                  type="primary"
                  className="bg-color-primary h-full text-white text-lg rounded-md px-2 w-full"
                  htmlType="button"
                  onClick={() => {
                    setStep(2);
                  }}
                >
                  {intl.formatMessage({
                    id: "continue",
                    defaultMessage: "الإستمرار",
                  })}
                </Button>
              </Col>
              <Col xl={12} lg={12} xs={24} sm={24}>
                <Button
                  type="primary"
                  block
                  className="btn-primary-light"
                  htmlType="button"
                  onClick={onClose}
                >
                  {intl.formatMessage({
                    id: "cancel",
                    defaultMessage: "الغاء",
                  })}
                </Button>
              </Col>
            </div>
          </Form>
        </div>
      ) : (
        <AddTime
          location_id={location_id}
          onBackStep={() => setStep(1)}
          onClose={onClose}
          team_member_id={team_member_id}
          shiftDays={shiftDays}
          selectedDate={selectedDate}
          config={config}
        />
      )}
      {config?.isEdit ? (
        <div className="text-[#C43535] text-base font-medium flex items-center justify-center mt-8">
          <DeleteModal
            visible={openDeleteModal}
            onClose={() => {
              setOpenDeleteModal(false);
            }}
            // onDelete={adminDeleteTeamMember} // Pass the delete function for "Package"
            onDelete={adminDeleteWorkingHours}
            data={config?.workingHoursWithShifts?.id}
            confirmationHeader={
              "Are you sure you want to delete this working hours?"
            }
            confirmationText={""}
            queryKey={"TeamMember"} // Pass the correct key here
            successMessage={"Working hours deleted successfully"}
            afterDelete={onClose}
          />
          <Button
            type="text"
            danger
            block
            htmlType="button"
            icon={<MdOutlineDeleteForever className="text-lg" />}
            // className="bg-white py-3 min-w-[150px] rounded-r-lg text-[#00086D] font-semibold"
            onClick={() => {
              setOpenDeleteModal(true);
            }}
          >
            Delete Working Shifts
          </Button>
        </div>
      ) : null}
    </>
  );
};

export default AddSchedule;
